window.$ = window.jQuery = require('jquery');

require('vgnav/index');
require('../../vendor/vegas/form-sender/js/jquery.vegasFormSender');
require('../../vendor/vegas/form-sender/js/alert.vegasFormSender');
require('../../vendor/vegas/scrollTo/jquery.vegasScrollTo');

require('../vendor/bootstrap/bootstrap.min');
require('jquery-nice-select/js/jquery.nice-select.min');
require('../vendor/OverlayScrollbars/jquery.overlayScrollbars.min');
require('../vendor/slick/slick.min');

require('./modules/vegas');
require('./modules/search');
require('./modules/CatalogCategories');
require('./modules/svgGenerator');
require('./modules/ym');
require('./modules/map');
require('./modules/input-counter');

require('../../modules/vegas/js/carousel');
require('../../modules/vegas/js/functions');
require('../../modules/vegas/js/mask');

require('./modules/cart');
require('./modules/catalog');
// [[vegas]]

require('./custom');